<ng-container *ngIf="showUnderline; else simple">
  <div
    class="pulse-card relative block border-gray-100 border p-6 m-6 bg-white p-8 overflow-hidden rounded-lg"
  >
    <span
      class="absolute inset-x-0 bottom-0 h-2 bg-gradient-to-tr from-primary-500 to-secondary-500"
    ></span>
    <ng-content></ng-content>
  </div>
</ng-container>

<ng-template #simple>
  <div
    class="pulse-card w-full border p-6 mb-6 bg-white rounded-lg overflow-hidden"
    [ngClass]="{ relative: underlined }"
  >
    <span
      [ngClass]="{ absolute: underlined }"
      class="inset-x-0 bottom-0 h-1 bg-gradient-to-tr from-primary-500 to-secondary-500"
    ></span>
    <ng-content></ng-content>
  </div>
</ng-template>
